import type { ProductWizardContext } from '../context/ProductWizardContext';

export class DeliverySheetSizeHelper {
  constructor(protected context: ProductWizardContext) {}

  public static readonly DELIVERY_SHEET_WIDTH_DEFAULT = 204;
  public static readonly DELIVERY_SHEET_HEIGHT_DEFAULT = 270;
  public static readonly DELIVERY_SHEET_WIDTH_MINIMUM = 25;
  public static readonly DELIVERY_SHEET_HEIGHT_MINIMUM = 25;
  public static readonly DELIVERY_SHEET_INSIDE_PADDING_DEFAULT = 2;
  public static readonly DELIVERY_SHEET_OUTSIDE_PADDING_DEFAULT = 0;

  public setDefaultValues(): void {
    this.context.productItem.setAttrValue(
      'delivery_sheet_width',
      DeliverySheetSizeHelper.DELIVERY_SHEET_WIDTH_DEFAULT,
    );
    this.context.productItem.setAttrValue(
      'delivery_sheet_height',
      DeliverySheetSizeHelper.DELIVERY_SHEET_HEIGHT_DEFAULT,
    );
    this.context.productItem.setAttrValue(
      'delivery_sheet_inside_padding',
      DeliverySheetSizeHelper.DELIVERY_SHEET_INSIDE_PADDING_DEFAULT,
    );
    this.context.productItem.setAttrValue(
      'delivery_sheet_outside_padding',
      DeliverySheetSizeHelper.DELIVERY_SHEET_OUTSIDE_PADDING_DEFAULT,
    );
  }

  public get sheetHeight(): number {
    return this.toFixedInt(this.context.productItem.getAttrValue('delivery_sheet_height'));
  }

  public get sheetWidth(): number {
    return this.toFixedInt(this.context.productItem.getAttrValue('delivery_sheet_width'));
  }

  public get minimumSheetWidth(): number {
    return DeliverySheetSizeHelper.DELIVERY_SHEET_WIDTH_MINIMUM;
  }

  public get minimumSheetHeight(): number {
    return DeliverySheetSizeHelper.DELIVERY_SHEET_HEIGHT_MINIMUM;
  }

  public get insidePadding(): number {
    return this.toFixedInt(this.context.productItem.getAttrValue('delivery_sheet_inside_padding'));
  }

  public get outsidePadding(): number {
    return this.toFixedInt(this.context.productItem.getAttrValue('delivery_sheet_outside_padding'));
  }

  private toFixedInt(value: unknown): number {
    const fixedValue = parseInt(Number(value).toFixed(0));

    return isNaN(fixedValue) ? 0 : fixedValue;
  }
}
